import React from "react";

const Directory = () => {
  return (
    <svg
      width="14"
      height="10"
      viewBox="0 0 14 10"
      fill="black"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.91199 3.75L1.59124 8.75V2.5H12.2831C12.2831 2.16848 12.1505 1.85054 11.9146 1.61612C11.6787 1.3817 11.3588 1.25 11.0252 1.25H6.62268L5.36482 0H1.59124C1.25763 0 0.937688 0.131696 0.701793 0.366116C0.465898 0.600537 0.333374 0.918479 0.333374 1.25V8.75C0.333374 9.08152 0.465898 9.39946 0.701793 9.63388C0.937688 9.8683 1.25763 10 1.59124 10H11.0252C11.5912 10 12.0944 9.625 12.2202 9.0625L13.6667 3.75H2.91199ZM11.0252 8.75H2.8491L3.85539 5H12.0315L11.0252 8.75Z"
        fill="black"
      />
    </svg>
  );
};

export default Directory;
